export default __webpack_public_path__ + "f09d12ac6b13c2d85a2828c0148e2fec.png";